import HttpRepository from './httpRepository'

export default class OrganizationRepository extends HttpRepository {
  getByName(name) {
    return this.get(`/v1/organization/top/${name}`)
  }
}
